import { render, staticRenderFns } from "./DiscountItem.vue?vue&type=template&id=851a808a&scoped=true"
import script from "./DiscountItem.vue?vue&type=script&lang=js"
export * from "./DiscountItem.vue?vue&type=script&lang=js"
import style0 from "./DiscountItem.vue?vue&type=style&index=0&id=851a808a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "851a808a",
  null
  
)

export default component.exports